import { Screen, ShowOn } from 'component-library/components/wrappers/ShowOn';
import React, { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

interface StyledWrapperProps {
  maxWidth?: number;
  padding?: string;
}

const StyledWrapper = styled(ShowOn)<StyledWrapperProps>`
  margin: auto;
  padding: ${({ padding }) => padding || '0px 20px'};
`;

interface MobileWrapperProps extends StyledWrapperProps {}

export const MobileWrapper: FC<PropsWithChildren<MobileWrapperProps>> = ({
  children,
  padding,
}) => (
  <StyledWrapper screens={[Screen.Sm, Screen.Md]} padding={padding}>
    {children}
  </StyledWrapper>
);
